export default {
    top_menu: [
        {name:'Asosiysi',   id:0},
        {name:'Shou-biznes', id:1},
        {name:'Pishirish',  id:2},
        {name:'Siyosat',   id:3},
        {name:'Achchiq',  id:4},
        {name:'Jamiyat',   id:5},
        {name:'Salomatlik',   id:6},
    ],
    read_other: "Davomini o'qish",
    read_more:  "Batafsil ma'lumot",
    not_found:  'Hech narsa topilmadi',
    read_also:  "Shuningdek o'qing",
    copy_rights: 'Copyright © 2019 «mixer-novostei.ru». Barcha huquqlar himoyalangan.',
    subscribe: "Obuna bo'lish",

    thank_order: 'Buyurtma uchun RAHMAT',
    specialist_contact: "Bizning mutaxassis tez orada siz bilan bog'lanadi, qo'ng'irog'imizni kuting.",
    attention: 'Hamkorlardan chegirmalar:',
    hurry: 'Shoshiling, chegirmalarni yoqish muddati cheklangan! Noyob mahsulotlardan birini tanlash uchun atigi  <span id="time" class="time">30:00</span> daqiqa vaqtingiz bor:',
    
    hour_ago1: "Bir soat oldin",
    hour_ago2: "soat oldin",
    hour_ago3: "soat oldin",
    new_publications: "Yangi nashrlar",
    read: "O'qing",
    today_at: "Bugun soat",
    author_names: ['Lola Ravshanbekovna','Farrux Zokirov','Sevara Nazarxon'],
    main_news: "Asosiy yangiliklar",
    leave_already: "Allaqachon ketayapsizmi? Kutib turing, biz siz uchun yangiliklarni yangiladik",
    already_shared: "allaqachon ulashilgan"

}